<template>
  <div class="container">
    <div class="back" @click="back"></div>
    <div class="title">NIKE個資聲明及免責同意書</div>
    <img class="disclaim-logo" src="../assets/image/logo_nike.png" />


    <scroll-view class="scroll-box" :scroll-y='true' :enhanced="false" :show-scrollbar="false" >
      <div id="content" class="content">
 
        請您在報名參加必爾斯藍基股份有限公司及其關聯公司（以下稱「NIKE」）或NIKE指定的第三方合作夥伴（以下合稱「主辦方」）組織及舉辦的活動（以下稱「活動」）之前，仔細閱讀本「NIKE個資聲明及免責同意書」（下稱「同意書」）。若您報名參加活動（不論是否通過點擊活動報名頁面上的按鍵報名、提交書面紙本或其他形式報名），即代表您（或稱「活動參加人」）已完整閱讀、充分理解並完全同意本同意書的各項約定，特別是其中免除或限制主辦方責任的條款。如果您不同意本同意書或其中的任何內容，請您不要報名參加活動。<br />

        活動參加人及/或其法定監護人，在此確認並同意以下：<br />

        1.資格。<br />
        您必須為活動參加人本人並具有合法身份證明；活動參加人須身體健康、不是先天性心臟病和風濕性心臟病患者/高血壓和腦血管疾病患者/心肌炎和其它心臟病患者/冠狀動脈病患者和嚴重心率不齊者/糖尿病患者/其他不適合運動的疾病患者，並且符合主辦方關於活動參加人的其他資格要求。<br />

        2.遵守法律和活動規則。<br />
        活動參加人瞭解並同意遵守一切適用於活動參加人參與活動的法律、法規、制度、規則、條款、本同意書和相關的NIKE及協力廠商隱私政策（統稱「活動規則」），並且瞭解違反該等活動規則可能帶來的後果。活動參加人同意遵守活動規則並配合主辦單位現場人員指示。<br />

        3.未成年人。<br />
        活動參加人符合法定年齡（18歲或以上），且具有適用法律規定的參加活動相應的行為能力。若您是未成年人或不具備前述行為能力，您應確保在您的父母或法定監護人的陪同下閱讀本同意書，並在獲得您的父母或法定監護人同意的前提下參加活動。<br />

        4.不利用活動進行宣傳。<br />
        未經主辦方事先書面許可，活動參加人同意不利用本次活動或參加活動本身進行任何形式的商業性或非商業性的市場開發或宣傳活動等。<br />

        5.風險的承擔。<br />
        活動參加人理解並同意，儘管免責方（如第6條內定義）會盡最大努力保證活動參加人安全，參加或列席活動可能存在固有風險和危險，可能遭受人身傷害和財產滅失或損壞。活動參加人及他人的作為或不作為、遊戲規則、相關設施和設備的狀況等均可能造成上述事故。此外，還可能存在活動參加人尚未知悉的且/或在合理情況下無法預見的其他風險。活動參加人已對活動中可能存在的風險的性質和程度進行考量，在法律允許的範圍內，自願選擇承擔所有已知或未知的風險，無論該等風險系由免責方的疏忽還是他人的疏忽造成。活動參加人對活動參加人參加本次活動的行為負全部責任。活動參加人同意，若在緊急事故或其他活動中，現場工作人員合理判斷活動參加人需要醫療服務，活動參加人將接受該等醫療服務。活動參加人進一步同意支付與該等醫療服務有關的一切費用，並補償免責方因該等醫療服務產生的一切費用或索賠，使其免於損害。<br />

        6.責任的免除。<br />
        6.1.	在法律允許的範圍內，活動參加人代表活動參加人及活動參加人的繼承人、信託人、承保人、繼任人和受讓人在此全面、永久地免除主辦方、主辦方的關聯公司和子公司及其各自的管理人員、董事、股東、員工、代理人、代表、志工、工作人員等（合稱「免責方」）因活動參加人遭受的與活動有關的人身傷害或財產損失而提起的一切索賠或訴訟中的責任，無論該等事件是否由免責方的疏忽引起的還是另有原因。<br />
        6.2.	活動中可能提供有關體育活動、營養或身心健康之宣導。這些內容僅供參考之用，不作醫療建議、醫療服務、診斷或治療之用。請在參與任何體育活動前考慮涉及的風險，並諮詢醫療專業人士，也請不要因為任何內容而忽視專業醫療建議或延遲尋求醫療建議。<br />

        7.所有權。<br />
        活動參加人瞭解並同意，本次活動可能會被以拍照、錄影或以其他方式進行記錄。活動參加人同意，NIKE是該等拍照、錄影和/或記錄所形成的作品的唯一所有權人。NIKE無須就使用該等記錄和作品向活動參加人或任何協力廠商支付任何額外報酬。活動參加人進一步同意，NIKE有權在全球範圍內，以NIKE認為合適的方式，永久地將活動參加人的名字、聲音和肖像，用於照片、錄影帶、錄音帶及其他一切已知的或將來開發的媒體，且NIKE無需為此向活動參加人或任何第三方支付任何額外報酬。<br />

        8.活動參加人創作內容。<br />
        活動參加人瞭解並同意，您在參加活動中有可能需要拍攝、製作諸如照片、視頻、圖片、創意、評論、短語及/或文字、角色、人物塑造等原創作品，並經由線上或線下方式上傳或提供給NIKE並在NIKE平臺（包括NIKE運營、管理及/或維護的網站、應用程式、小程式、數位體驗、社交媒體平臺、可穿戴技術或其他商品或服務）或NIKE線下店鋪進行展示，以完整地參加本次活動。您應保證上述作品本身及其製作、上傳和提供不會侵犯任何人的肖像權、隱私權、著作權及其他智慧財產權等合法權利，且獲得了必要授權。您同時授權NIKE及其關聯企業無償、永久的、全球範圍的不受限制地展示、修改、使用、編輯、傳播和複製該作品（除非相關法律禁止），並同意在上述作品本身或其製作、上傳、提供被確認侵犯他人權利或違法時，您會獨立承擔相應法律責任並使NIKE免於承擔法律責任或其他法律風險。您同時確認，NIKE有權隨時以任何理由將上述作品從NIKE可以合理控制的平臺或場所移除。<br />

        9.對活動參加人意見、回饋和想法的許可。<br />
        活動參加人在此授予NIKE一項永久許可，允許其使用活動參加人告知其的一切意見、回饋和想法。活動參加人同意NIKE可以將該等意見、回饋和想法用於任何目的，包括但不限於產品和服務的開發、生產、銷售、製造、改裝或改進，且無須向活動參加人支付費用。<br />

        10.個人資料蒐集聲明。<br />
        10.1.	活動參加人特此證明在活動註冊過程中提供的資料真實正確。活動參加人理解如果任何資料被證明不準確，主辦方有權排除您參與活動。<br />
        10.2.	蒐集個資目的：您參加本次活動時，NIKE依據個人資料保護法及相關法令之規定，為了本次活動之活動聯繫、活動公告、後續處理、紀錄、提供NIKE品牌產品及服務相關之行銷活動資訊等行銷目的使用之用途，將您的個人資料進行蒐集、處理、利用及國際傳輸。<br />
        10.3.	蒐集之個人資料：NIKE向您蒐集的個人資料，依據「個人資料保護法之特定目的及個人資料之類別」包括：（1）姓名；（2）聯絡電話；（3）社交帳號（如：Line ID）；（4）性別；（5）鞋碼；（6） 跑速；（7）運動表現數據；及（8）其他報名活動時提供主辦方之個人資料。<br />
        10.4.	個人資料利用之對象、地區、期間或方式： <br />
          （1）	對象：NIKE、主辦方及為NIKE進行資料維護、處理及寄送之服務供應商、NIKE經銷商、協助舉辦活動之NIKE門市、NIKE合作之行銷公司及協力廠商。 <br />
          （2）	地區：前開對象所在地及國際傳輸所涉地點，包括但不限於中華民國。 <br />
          （3）	期間：個人資料蒐集目的之存續期間、依相關法令或契約約定之保存期限、主辦方及合作夥伴因執行業務所必須之保存期間。 <br />
          （4）	方式：以自動化機器或其他非自動化之利用方式，包括但不限於以書面、電話、簡訊、傳真、電子郵件、網際網路、紙本或其他適當方式，對您提供的個人資料進行蒐集、處理及利用。 <br />
        10.5.	依個人資料保護法之規定，您得就個人資料行使以下權利： <br />
        NIKE及其合作夥伴對您的個人資料，將採取妥適的安全措施加以保護。您可隨時透過NIKE官方網站揭露之通訊方式，就您提供的個人資料行使下列權利：(1)請求查詢或閱覽；(2)製給複製本；(3)請求補充或更正；(4)請求停止蒐集、處理及利用；及(5)請求刪除。若有個人資料權益相關問題，請來信digital.taiwan@nike.com並註明您的姓名以及活動名稱。於收到您的要求後，我們將在相關法令許可之範圍及合理期間內依您的要求進行處理。<br />
        10.6.	若您不欲提供相關個人資料，將可能影響您參加本次活動或取得主辦單位活動參與之權益。<br />


        11.變更。<br />
        NIKE 保留修改本活動及拒絕活動參與之權利。主辦方有權決定取消、終止、修改或暫停本次活動，活動參加人同意屆時將遵循主辦方的通知與調整。<br />

        12.其他。<br />
        12.1.	如有違反公序良俗、惡意詆毀或散佈與事實不符之不當言論內容，NIKE有權立即取消您參與活動資格、刪除影片及網路留言內容。並對於任何可能從事詐欺或其他破壞本活動行為保留採取法律行動之權利。<br />
        12.2.	如果本同意書的任何部分被認定為無效，活動參加人同意其餘條款將繼續具有完全的效力。<br />
        12.3.	活動參加人與主辦方之間的任何糾紛、爭議或損害賠償應首先由當事人間通過友好協商解決，若無法協商解決而涉訟，雙方同意以臺灣臺北地方法院為第一審訴訟之管轄法院。<br />

      </div>
    </scroll-view>


    <div class="btn" @click="back">確認</div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  methods: {
    back() {
     this.$router.back()
    },
  },
  onLoad() {

  }
}
</script>

<style scoped lang="less">
.container {
  background-color: #fff;
}
.back {
  position: relative;
  top: 18vw;
  left: 10.66vw;
  width: 5vw;
  height: 5vw;
  border-bottom: 2px solid #000000;
  border-left: 2px solid #000000;
  transform: rotate(45deg);
}

.title {
  position: absolute;
  top: 36.2vw;
  left: 5.6vw;
  font-size: 6.9vw;
  color: #000;
  font-weight: bold;
  font-family: 'en-bold', 'fs-bold';
}

.disclaim-logo {
  position: absolute;
  top: 15.46vw;
  right: 6.13vw;
  width: 26.67vw;
  height: 10vw;
}

.btn {
  position: absolute;
  bottom: 9vw;
  width: 87.2vw;
  height: 10.67vw;
  left: 6.4vw;
  border-radius: 60px;
  line-height: 10.67vw;
  color: #fff;
  background-color: #000;
  text-align: center;
  font-size: 3.7vw;
  font-family: 'fs-bold';
}

.scroll-box {
  position: absolute;
  top: 50vw;
  left: 6.4vw;
  width: 87.2vw;
  right: 6.4vw;
  bottom: 40vw;
  color: #000;
  font-size: 3.7vw;
  overflow: auto;
  font-family: 'en-medium', 'fs-regular';
  .content {
    font-weight: normal;
    padding: 0;
    text-align: left;

    .table {
      margin: 4vw 0;
      width: 100%;

      div {
        width: 100%;
        display: flex;

        &:first-child {

          text-align: center;

          span {
            text-indent: 0;
          }
        }

        span {
          padding: 1.3vw 0.65vw;
          flex: 1;
          border: 1px solid #000;
          text-indent: 2em;
        }
      }
    }
  }
}


</style>


// WEBPACK FOOTER //
// src/pages/disclaim.vue